var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-desktop',{class:{ 'd-none': !_vm.isRoot, 'd-lg-block': true, 'd-block': _vm.isRoot }}),(!_vm.isRoot)?_c('header-mobile',{staticClass:"d-block d-lg-none"}):_vm._e(),_c('main',{staticClass:"layoutSubMain",class:{
      pt40: _vm.isPlayTrialModeMobile,
      marginB: _vm.marginB
    }},[_vm._t("default")],2),_c('Footer',{staticClass:"d-none d-lg-block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }